(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/views/consent-landing.js') >= 0) return;  svs.modules.push('/modules/player-login/views/consent-landing.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login=_svs.player_login||{};
_svs.player_login.templates=_svs.player_login.templates||{};
svs.player_login.templates.consent_landing = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"padding-top-4 padding-bottom-4 padding-left-2 padding-right-2 f-content align-center\">\n        <h1>Klart!</h1>\n        <p>Dina val har sparats och du kan när som helst ändra dessa via länken \"Välj dina cookies\" som du hittar längst ned på varje sida på vår sajt.</p>\n        <a href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"redirect") || (depth0 != null ? lookupProperty(depth0,"redirect") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"redirect","hash":{},"data":data,"loc":{"start":{"line":6,"column":17},"end":{"line":6,"column":29}}}) : helper)))
    + "\" class=\"btn btn-300 btn-inverted\" title=\"Fortsätt\">\n            <span class=\"btn-link-text\">Fortsätt</span>\n        </a>\n    </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"consent-landing padding-left-1 padding-right-1\">\n"
    + ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"paper",{"name":"ui","hash":{"branding":"sport"},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":10,"column":11}}})) != null ? stack1 : "")
    + "</section>\n";
},"useData":true});
Handlebars.partials['svs-player_login-consent_landing'] = svs.player_login.templates.consent_landing;
})(svs, Handlebars);


 })(window);